export const isNumber = (value: unknown | undefined): value is number =>
  Number.isInteger(value)
